import LogRocket from "logrocket";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

import upgradeReducer from "../features/auth/reducer";
import ordersReducer from "../features/reading/reducer";

const persistConfig = {
  key: "root",
  storage: storage,
  stateReconciler: autoMergeLevel2,
};

const rootReducer = combineReducers({
  orders: persistReducer(persistConfig, ordersReducer),
  upgrade: persistReducer(persistConfig, upgradeReducer),
});

const middleware = [thunk, LogRocket.reduxMiddleware()];

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// if (process.no) {
//   NativeModules.DevSettings.setIsDebuggingRemotely(true);
// }

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export const persistor = persistStore(store);

export const resetStore = async () => {
  await persistor.purge();
  store.dispatch(resetStore());
  await persistor.flush();
};

// resetStore();
